<script setup>
import {Permissions} from "@/Utils/Permissions";
import RolesComponent from "@/Components/ManageRoles/RolesComponent.vue";
import FederatedGroupsComponent from "@/Components/ManageRoles/FederatedGroupsComponent.vue";
</script>

<template>
  <v-container fluid style="min-height: 100vh;">
    <v-row>
      <v-col cols="12" sm="6" v-if="Permissions.checkPermissions([],true)">
        <RolesComponent/>
      </v-col>
      <v-col cols="12" sm="6" v-if="Permissions.checkPermissions([],true)">
        <FederatedGroupsComponent/>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>

</style>